import { API_ENDPOINTS, API_HEADERS } from '../constants/api';
import { ContactPayload } from '../types';

export const fetchContactInfo = async (): Promise<ContactPayload | null> => {
  const response = await fetch(API_ENDPOINTS.contact, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Contact request failed with status ${response.status}`);
  }

  const data: ContactPayload[] | { results: ContactPayload[] } = await response.json();

  // Handle array response directly
  if (Array.isArray(data) && data.length > 0) {
    // Get the latest entry (highest id) or first entry
    return data.sort((a, b) => (b.id || 0) - (a.id || 0))[0];
  }

  // Handle wrapped response with results
  if (!Array.isArray(data) && Array.isArray(data?.results) && data.results.length > 0) {
    return data.results.sort((a, b) => (b.id || 0) - (a.id || 0))[0];
  }

  return null;
};

